/* ШКАЛА ПРОГРЕССА — ОДНА НА ОБА ЭКРАНА КАБИНЕТА.

   ПОЛОСКИ СЧИТАЮТСЯ ОТ ОТМЕЧЕННЫХ ПУНКТОВ, а не от часов. Это не оформление, а
   смысл: рядом со шкалой стоит число «3 из 4», и говорить она обязана ровно то
   же самое. На странице плана до 16.09 полоски заполнялись по `state` этапа
   (позади / идёт / впереди), то есть по календарю: в первый день плана позади
   нет ни одного этапа, и пациент, отметивший три пункта из четырёх, видел пустую
   полосу в сантиметре от числа «3 из 4». Число и шкала спорили друг с другом.

   НЕ БОЛЬШЕ ДЕСЯТИ ПОЛОСОК: в макете их четыре-пять, а план на девять пунктов
   превратил бы шкалу в шум. Сверх десяти полоски перестают считать пункты
   поштучно и показывают долю — число рядом остаётся точным. */
const MAX_SEG = 10;

export function segments(done: number, total: number): { total: number; filled: number } {
    const n = Math.max(1, Math.min(total, MAX_SEG));
    return { total: n, filled: total > 0 ? Math.round((done / total) * n) : 0 };
}

/** Дней до ближайшего касания — ЗЕРКАЛО серверного `next_touch_day`
 *  (`post-care-api/src/routers/tools/progress.py`), включая его правило: `null`
 *  отдаётся РОВНО когда план завершён, а «впереди этапов нет» — это ноль.
 *
 *  Зачем зеркало, если число уже приезжает с сервера. Отметка пункта
 *  пересчитывается на месте (запрос отдаёт пустой 200), и вместе с ней меняется
 *  `completed`. Серверный `nextDay` при этом остаётся прежним — а он с
 *  `completed` СВЯЗАН. Снятая отметка у завершённого плана давала пару
 *  «не завершён» + `nextDay: null`, которой на сервере не бывает, и подпись
 *  печатала «План завершён — следующих касаний нет» под числом «3 из 4». */
export function nextTouchDay(days: number[], dayNumber: number, completed: boolean): number | null {
    if (completed) return null;
    for (const day of [...days].sort((a, b) => a - b)) {
        if (day > dayNumber) return day - dayNumber;
    }
    return 0;
}
